import { FC, PropsWithChildren } from "react";

export const AssetLabel: FC<
  PropsWithChildren<{
    asset?: { metadata: { symbol: string }; chain: string } | null | undefined;
    Container: FC<PropsWithChildren>;
  }>
> = ({ asset, Container }) =>
  asset ? (
    <>
      {asset.metadata.symbol}
      {(asset.metadata.symbol === "USDT" ||
        (asset.metadata.symbol === "ETH" && asset.chain !== "ETH") ||
        (asset.metadata.symbol === "USDC" && asset.chain !== "ETH")) && (
        <Container>.{asset.chain}</Container>
      )}
    </>
  ) : null;
